export const maskConfig = {
  separatorLimit: '1000000000000',
  thousandSeparator: ',',
  currency: '$',
  percentage: '%',
};
